// Finds where a pointer was dragged over an element: a leading/trailing edge band
// ('before'/'after') or the middle ('inside'). Ported from the analytics report
// builder (reportBuilder2/utils/dragAndDrop.js) so the questionnaire builder and the
// live report builder share one drag model.
//
// AI-CONTEXT: See docs/features/questionnaire-sections.md (T1 foundation helpers)
const getDropZone = ({
    pointer,
    rect,
    axis,
    thresholdRatio = 0.25,
    minThreshold = 20,
}) => {
    const start = axis === 'x' ? rect.left : rect.top
    const size = axis === 'x' ? rect.width : rect.height
    const edgeThreshold = Math.max(size * thresholdRatio, minThreshold)

    if (pointer < start + edgeThreshold) {
        return 'before'
    }

    if (pointer > start + size - edgeThreshold) {
        return 'after'
    }

    return 'inside'
}

export default getDropZone
